/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sync_Vekn_Tournaments_DescInputs */



/**
* | output |
* | --- |
* | "Pull tournament results from VEKN. Runs automatically every 6 hours." |
*
* @param {Admin_Sync_Vekn_Tournaments_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_sync_vekn_tournaments_desc = /** @type {((inputs?: Admin_Sync_Vekn_Tournaments_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sync_Vekn_Tournaments_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Récupère les résultats des tournois depuis VEKN. S'exécute automatiquement toutes les 6 heures.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descarga los resultados de torneos desde VEKN. Se ejecuta automáticamente cada 6 horas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Baixa os resultados de torneios do VEKN. Executado automaticamente a cada 6 horas.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica i risultati dei tornei da VEKN. Viene eseguita automaticamente ogni 6 ore.")
	return /** @type {LocalizedString} */ ("Pull tournament results from VEKN. Runs automatically every 6 hours.")
});